import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ActionCreatePermissions } from './entities/action-create-permissions';
import { UntypedFormGroup } from '@angular/forms';
import Utils from 'app/Utils';

@Injectable({
  providedIn: 'root'
})
export class ActionCreationService {

  public actionCreatePermissions: ActionCreatePermissions = new ActionCreatePermissions();

  constructor(
    private router: Router
  ) {
    this.setViewPermissions();
  }

  cancelAction(): void {
    this.router.navigateByUrl('/employee');
  }

  setViewPermissions(): void {
    const permissions: Array<string> = Utils.decrypt(localStorage.getItem('permissionIds')) != null ? 
      Utils.decrypt(localStorage.getItem('permissionIds')).split(',') : [];

    if (permissions.includes('524')) {
      this.actionCreatePermissions.HasVisitaMedico = true;
    }

    if (permissions.includes('525')) {
      this.actionCreatePermissions.HasVisitaGestion = true;
    }

    if (permissions.includes('605')) {
      this.actionCreatePermissions.HasCreateVisita = true;
      this.actionCreatePermissions.HasCreateVisitaAusente = true;
      this.actionCreatePermissions.HasCreateInformeMedico = true;
    }

    if (permissions.includes('604')) {
      this.actionCreatePermissions.HasCreateContacto = true;
      this.actionCreatePermissions.HasCreateGestionConMutua = true;
    }

    if (permissions.includes('608')) {
      this.actionCreatePermissions.HasCreateContactoAdministrativo = true;
      this.actionCreatePermissions.HasCreateContactoAdministrativoFallido = true;
    }

    if (permissions.includes('619')) {
      this.actionCreatePermissions.HasCreateSolicitud = true;
    }

    if (permissions.includes('601')) {
      this.actionCreatePermissions.HasCreateDocumentoNoMedico = true;
    }

    if (permissions.includes('607')) {
      this.actionCreatePermissions.HasCreateComentario = true;
      this.actionCreatePermissions.HasPermit607 = true;
    }

    if (permissions.includes('627')) {
      this.actionCreatePermissions.HasCreateComentario = true;
      this.actionCreatePermissions.HasPermit627 = true;
    }

    if (permissions.includes('618')) {
      this.actionCreatePermissions.HasCreateOrden = true;
    }

  }

  public markFormGroupTouched(formGroup: UntypedFormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
}
